/* eslint-disable ember/no-classic-components, getter-return */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tagName } from '@ember-decorators/component';
@tagName('')
export default class GroupButton extends Component {
  @service
  router;

  group = null;
  @tracked route = '';

  get selectedRoute() {
    switch (this.route) {
      case 'teach':
        return 'group.topics';
      case 'triangulate':
        return 'group.triangulation';
      case 'discuss':
        return 'group.data-wall';
      case 'posts':
        return 'group.posts';
    }
  }

  @action
  goToRoute(route, params) {
    this.router.transitionTo(route, ...params);
  }
}
